const LoadingSpinner = () => {
  return (
    <div className="w-full h-[410px] flex items-center justify-center">
      <div className="relative w-16 h-16">
        <div className="absolute top-0 left-0 w-full h-full border-4 border-prime-red/20 rounded-full"></div>
        <div className="absolute top-0 left-0 w-full h-full border-4 border-t-prime-red rounded-full animate-spin"></div>
      </div>
    </div>
  );
};

export default LoadingSpinner;
